var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"candidate-favorited-indicator d-flex align-items-center"},[_c('span',{staticClass:"material-icons-round md-14"},[_vm._v("favorite_border")]),_c('span',{staticClass:"mx-4"},[_vm._v(_vm._s(_vm.compact ? 'By' : 'Favorited by'))]),_c('span',[_vm._v(_vm._s(_vm.favoriteCount || 0))])])
}
var staticRenderFns = []

export { render, staticRenderFns }